import $ from "jquery";
import { setupMediaModal } from "./media-modal";
import { AnchorNav, injectAnchors, killAnchorNav } from "./anchor-nav";

(() => {
  // escape hatch
  if (!document.querySelector(".feed-container")) return;

  const feedContainer = document.querySelector(".feed-container");

  let state = {
    content: getOptionLabel(
      document.querySelector('.active[data-group="content"]')
    ).toLowerCase(),
    view: getOptionLabel(
      document.querySelector('.active[data-group="view"]')
    )?.toLowerCase(),
    // content filters are not always present and may be null
    contentFilter: getOptionLabel(
      document.querySelector('.active[data-group="content_filter"]')
    )?.toLowerCase(),
    sort: getOptionLabel(
      document.querySelector('.active[data-group="sort"]')
    )?.toLowerCase(),
  };

  if ("media" === state["content"]) {
    setupMediaModal();
  }

  function handleClick(e, withFocus = false) {
    const clicked = e.currentTarget;
    const group = clicked.dataset.group;
    const selection = getOptionLabel(clicked).toLowerCase();
    const groupElements = document.querySelectorAll(`[data-group=${group}]`);

    state[group] = selection;

    // UI classes
    groupElements.forEach((element) => {
      if (element === clicked) {
        element.classList.add("active");
      } else {
        element.classList.remove("active");
      }
    });

    // If a new content group is selected need to manage the filter bars
    if (group === "content") {
      const secondary = document.querySelectorAll(".feed-controls-secondary");
      secondary.forEach((secondaryControl) => {
        const optionsWrapper = secondaryControl.querySelector(".feed-options");
        if (optionsWrapper) {
          const parent = optionsWrapper.dataset.parent;
          toggleFilterMenu(
            secondaryControl,
            parent === getOptionLabel(clicked)
          );
        }
      });
    }

    // If a new view is selected we can just replace the class, otherwise need to replace the feed
    if (group === "view") {
      const feedTeasers = feedContainer.querySelector(".feed-teasers");
      let layoutType = selection;
      // If it's a media feed clicking on grid needs masonry class name rather than grid
      if (state["content"] === "media" && layoutType === "grid") {
        layoutType = "masonry";
      }
      feedTeasers.className = `feed-teasers feed-teasers-${layoutType}`;
      if (withFocus) {
        feedTeasers.querySelector("a").focus();
      }

      maybeToggleStickyNav();
    } else {
      killAnchorNav();
      replaceFeed().then(() => {
        maybeToggleStickyNav();
        if (withFocus) {
          feedContainer.querySelector(".feed-teasers a").focus();
        }
      });
    }
  }

  const feedOptionElements = document.querySelectorAll(".feed-option");
  feedOptionElements.forEach((option) => {
    option.addEventListener("click", handleClick);
    option.addEventListener("keypress", (e) => {
      if (e.keyCode === 13) handleClick(e, true);
    });
  });

  let activeRequest;

  function replaceFeed() {
    // If a new request is made before the previous one finishes the previous is aborted
    if (activeRequest) {
      activeRequest.abort();
    }

    // Show loader
    feedContainer.classList.add("loading");

    const feedTeasers = feedContainer.querySelector(".feed-teasers");
    const queryArgs = feedTeasers.dataset.query;
    const cacheId = feedTeasers.dataset.cache;

    // Get selected options
    const selectedOptions = {};
    feedOptionElements.forEach((option) => {
      if (option.classList.contains("active")) {
        selectedOptions[option.dataset.group] = getOptionLabel(option);
      }
    });
    // If search results or a single collection ensure the query doesn't attempt alternate sorting
    if (document.body.classList.contains("search-results")) {
      selectedOptions["sort"] = "None";
    }

    const requestData = {
      selected_options: selectedOptions,
      query_args: queryArgs,
      cache_id: cacheId,
    };

    // If it's a single collection need to get the collection id to pass in
    if (document.body.classList.contains("single-collection")) {
      selectedOptions["sort"] = "Index Title";
      document.body.classList.forEach((cssClass) => {
        if (cssClass.includes("postid")) {
          requestData["collection_id"] = cssClass.split("-")[1];
        }
      });
    }

    const endpoint = `${LOCALIZED.rest_url}hive/v1/generate-feed`;
    activeRequest = $.ajax(endpoint, {
      method: "POST",
      dataType: "json",
      data: requestData,
      success: function (response) {
        feedContainer.innerHTML = response;
        if ("Media" === requestData.selected_options.content) {
          setupMediaModal();
        }
      },
      complete: function () {
        // Hide loader
        feedContainer.classList.remove("loading");
      },
    });
    return activeRequest;
  }

  function toggleFilterMenu(filterMenu, toggleOn = false) {
    const filterOptions = filterMenu.querySelectorAll(
      "[data-group=content_filter]"
    );
    let selectedToggleCallback;
    // If toggle on, show the filter menu and select the All option
    if (toggleOn) {
      filterMenu.classList.add("active");
      selectedToggleCallback = (option) => {
        if (option.innerText.includes("All")) {
          option.classList.add("active");
        } else {
          option.classList.remove("active");
        }
      };
      // If toggle off hide the filter and remove all filter option selections
    } else {
      filterMenu.classList.remove("active");
      selectedToggleCallback = (option) => {
        option.classList.remove("active");
      };
    }
    filterOptions.forEach(selectedToggleCallback);
  }

  function getOptionLabel(option) {
    if (option) {
      const labelElement = option.querySelector(".feed-option-label") ?? option;
      return labelElement.innerText.split(" (")[0];
    }
  }

  function maybeToggleStickyNav() {
    if (document.body.classList.contains("search-results")) return;

    killAnchorNav();

    if (document.querySelector(".feed-teasers").offsetHeight < 750) return;

    // init sticky
    if (state.content === "articles" && state.view === "list") {
      document.querySelector(".block-post-index").appendChild(
        AnchorNav({
          anchors: injectAnchors({ mode: "alphabet" }),
          offset: 120,
          alphabet: true,
        })
      );
    }
  }
})();
